export default {
    getDaysBetweenDates(date1, date2) {
        if (!date1 || !date2) { return 0 }
        var difference_in_time = date2.getTime() - date1.getTime();  
        return (difference_in_time / (1000 * 3600 * 24));
    },

    getDates(start_date, stop_date) {
        var dateArray = new Array();
        var currentDate = new Date(start_date);
        currentDate.setDate(currentDate.getDate() + 1);
        while (currentDate <= stop_date) {
            dateArray.push(new Date (currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dateArray;
    },

    isBlockedByPeakSeason(start_date, end_date, cabin_prices) {
        if (!start_date || !end_date) { return false }
        return (
            this.isDatePeakSeasonAndBlockedDay(start_date, cabin_prices) ||
            this.isDatePeakSeasonAndBlockedDay(end_date, cabin_prices)
        );
    },

    isDatePeakSeasonAndBlockedDay(date, cabin_prices) {
        if (!date) { return false }
        if (date.getDay() == 0 || date.getDay() == 4) { return false }
        let current_cabin_price = cabin_prices.find(element => {
            return element.weeks.includes(this.getWeekNumber(date));
        })
        if (current_cabin_price == null) { return false }
        return current_cabin_price.block_partial_periods
    },

    getWeekNumber(date) {
        if (!date) { return -1 }
        var onejan = new Date(date.getFullYear(), 0, 1);
        return Math.ceil((((date - onejan) / 86400000) + onejan.getDay()) / 7);
    },

    getDaysArray(start, end) {
        if (!start || !end) { return [] }
        for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
            arr.push(new Date(dt).toISOString().split('T')[0]);
        }
        return arr;
    },

    isHolidayWeek(start_date, end_date) {
        if (!start_date || !end_date) { return false }
        return (
            this.isVasaRaceWeek(start_date) ||
            this.isVasaRaceWeek(end_date) ||
            this.isEasterWeek(start_date) ||
            this.isEasterWeek(end_date) ||
            this.isSportHolidayWeek(start_date) ||
            this.isSportHolidayWeek(end_date) ||
            this.isChristmasWeek(start_date) ||
            this.isChristmasWeek(end_date) ||
            this.isNewYearsWeek(start_date) ||
            this.isNewYearsWeek(end_date)
        );
    },

    isVasaRaceWeek(date) {
        if (!date) { return false }
        if (date.getDay() == 0) { return false }
        let dateOfRace = this.firstDayOfMonth(date.getFullYear(),2,'sun');
        return this.getWeekNumber(dateOfRace) === this.getWeekNumber(date);
    },

    isEasterWeek(date) {
        if (!date) { return false }
        if (date.getDay() == 0) { return false }
        let dateOfEaster = this.getEaster(date.getFullYear())
        return this.getWeekNumber(dateOfEaster) === this.getWeekNumber(date);
    },

    isSportHolidayWeek(date) {
        if (!date) { return false }
        if (date.getDay() == 0) { return false }
        return [7,8,9].includes(this.getWeekNumber(date));
    },

    isChristmasWeek(date) {
        if (!date) { return false }
        if (date.getDay() == 0) { return false }
        let dateOfChristmas = new Date(date.getFullYear(), 11, 24)
        return this.getWeekNumber(dateOfChristmas) === this.getWeekNumber(date)
    },

    isNewYearsWeek(date) {
        if (!date) { return false }
        if (date.getDay() == 0) { return false }
        let dateOfNewYears = new Date(date.getFullYear(), 11, 31)
        return this.getWeekNumber(dateOfNewYears) === this.getWeekNumber(date)
    },

    // usage e.g get first tuesday of mars 2012 lastDayOfMonth(2012,2,'tue');
    firstDayOfMonth(y,m,dy) {
        var  days = {sun:0,mon:1,tue:2,wed:3,thu:4,fri:5,sat:6}
        var dat = new Date(y, m, 1)
        var currentmonth = m
         
        while (currentmonth === m){
            if (dat.getDay() === days[dy]) {
                return dat;
            } else {
                dat.setDate(dat.getDate()+1);
            }
        }
    },
    
    getEaster(year) {
        var f = Math.floor,
            // Golden Number - 1
            G = year % 19,
            C = f(year / 100),
            // related to Epact
            H = (C - f(C / 4) - f((8 * C + 13)/25) + 19 * G + 15) % 30,
            // number of days from 21 March to the Paschal full moon
            I = H - f(H/28) * (1 - f(29/(H + 1)) * f((21-G)/11)),
            // weekday for the Paschal full moon
            J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
            // number of days from 21 March to the Sunday on or before the Paschal full moon
            L = I - J,
            month = 3 + f((L + 40)/44),
            day = L + 28 - 31 * f(month / 4);
        //return [month,day];
        return new Date(year, month-1, day)
    }
}